import React from 'react'
import styled from 'react-emotion'
import { space } from '../style'
import cavet from '../../media/img/icons/cavet.png'

const arrowSize = 10
export const Select = styled(
  ({ className, onChangeValue, stretch, reverse, ...props }) => {
    if (onChangeValue) {
      props.onChange = e =>
        onChangeValue(e.target.options[e.target.selectedIndex].value)
    }
    return <select className={className} {...props} />
  }
)(({ stretch, reverse }) => ({
  cursor: 'pointer',
  fontWeight: 500,
  textAlign: 'right',
  paddingRight: !reverse && space.small + arrowSize,
  paddingLeft: reverse && space.small + arrowSize,
  // put the label on the right
  // direction: 'rtl', // attempt to get label fixed to right. (causes select √ to also appear on right)
  textAlignLast: !stretch && 'right',
  width: stretch && '100%',

  border: 'none',
  appearance: 'none', // stop safari making it all roundy

  // new down arrow
  background: `url('${cavet}') no-repeat`,
  backgroundSize: arrowSize,
  backgroundPosition: `${reverse ? 'left' : 'right'} center`
}))

export default Select
